import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import React, { Component } from 'react';
import { document } from '../../../helpers/BrowserHelpers';
import Toolbar from './Toolbar';

var ToolbarContainer =
/*#__PURE__*/
function (_Component) {
  _inherits(ToolbarContainer, _Component);

  function ToolbarContainer(props) {
    var _this;

    _classCallCheck(this, ToolbarContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ToolbarContainer).call(this, props));

    if (props.containerId) {
      _this.scrollingContainer = document.getElementById(props.containerId);
    }

    _this.ref = React.createRef();
    return _this;
  }

  _createClass(ToolbarContainer, [{
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "position-relative zindex-null",
        ref: this.ref
      }, this.props.children, React.createElement(Toolbar, {
        editor: this.props.editor,
        parent: this.ref.current,
        store: this.props.store,
        insets: this.props.insets,
        scrollingContainer: this.scrollingContainer
      }));
    }
  }]);

  return ToolbarContainer;
}(Component);

export { ToolbarContainer as default };